import { Grid } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import * as React from "react";
import HeaderMobile from "../components/mobile/HeaderMobile";
import { SidebarMobile } from "../components/mobile/SidebarMobile";
import AppRoutes from "./AppRoutes";
import Header from "./Header";
import { Sidebar } from "./Sidebar";

const drawerWidth = 230;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MainLayout({
  setTypographyFontSize,
  typographyFontSize,
  setH6FontSize,
  h6FontSize,
  setH5FontSize,
  h5FontSize,
  setH4FontSize,
  h4FontSize,
  themeMode,
  setThemeMode,
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <Box sx={{ display: { xs: "block", md: "flex" }, width: "100%" }}>
      {!["/login", "/forgotPassword", "/reset-password"].includes(
        window.location.pathname
      ) &&
        !window.location.pathname.startsWith("/explore") &&
        !window.location.pathname.startsWith("/presentation/") &&
        !window.location.pathname.startsWith("/invitation") && (
          <>
            <Sidebar
              setOpen={setOpen}
              open={open}
              sx={{ display: { xs: "none", md: "block" } }}
            />
            <Header
              sx={{ display: { xs: "none", md: "block" } }}
              setOpen={setOpen}
              open={open}
              setTypographyFontSize={setTypographyFontSize}
              typographyFontSize={typographyFontSize}
              setH6FontSize={setH6FontSize}
              h6FontSize={h6FontSize}
              setH5FontSize={setH5FontSize}
              h5FontSize={h5FontSize}
              setH4FontSize={setH4FontSize}
              h4FontSize={h4FontSize}
              themeMode={themeMode}
              setThemeMode={setThemeMode}
            />
            <SidebarMobile
              setOpen={setOpen}
              open={open}
              sx={{ display: { xs: "block", md: "none" } }}
            />
            <HeaderMobile
              sx={{ display: { xs: "block", md: "none" } }}
              setOpen={setOpen}
              open={open}
              setTypographyFontSize={setTypographyFontSize}
              typographyFontSize={typographyFontSize}
              setH6FontSize={setH6FontSize}
              h6FontSize={h6FontSize}
              setH5FontSize={setH5FontSize}
              h5FontSize={h5FontSize}
              setH4FontSize={setH4FontSize}
              h4FontSize={h4FontSize}
              themeMode={themeMode}
              setThemeMode={setThemeMode}
            />
          </>
        )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p:
            window.location.pathname.startsWith("/explore") ||
            window.location.pathname.startsWith("/presentation/")
              ? 0
              : 2,
        }}
      >
        {
          <Grid
            container
            spacing={
              window.location.pathname.startsWith("/explore") ||
              window.location.pathname.startsWith("/presentation/")
                ? 0
                : 2
            }
            sx={{
              marginTop:
                window.location.pathname.startsWith("/explore") ||
                window.location.pathname.startsWith("/presentation/")
                  ? "0px"
                  : "45px",
            }}
          >
            <Grid item xs={12}>
              <AppRoutes />
            </Grid>
          </Grid>
        }
      </Box>
    </Box>
  );
}
